<div
  class="oi-container"
  [class.oi-focus]="isFocus"
  [class.oi-has-value]="hasValue"
  [class.oi-disabled]="isDisabled"
  [ngClass]="{
    'oi-pristine': !isDirty,
    'oi-dirty': isDirty,
    'oi-touched': formControl.touched,
    'oi-untouched': !formControl.touched,
    'oi-valid': formControl.valid,
    'oi-invalid': !formControl.valid
  }"
>
  <span
    class="input-label"
    [class.stacked]="labelStacked"
    *ngIf="label"
    (click)="key.setFocus()"
    (keypress)="true"
    >{{ label }}</span
  >
  <ion-icon
    class="icon-eye"
    *ngIf="(isFocus || hasValue) && originalType === 'password'"
    [name]="tempType !== 'text' ? 'eye-off' : 'eye'"
    (click)="tempType = tempType === 'text' ? 'password' : 'text'"
    (keypress)="true"
  >
  </ion-icon>
  <ion-input
    class="oi-input"
    [(ngModel)]="value"
    [type]="tempType"
    #key
    [minlength]="minlength"
    [maxlength]="maxlength"
    [autocomplete]="autocomplete"
    (ionFocus)="onFocus()"
    (ionBlur)="onBlur()"
    (ionChange)="onChange(this.value)"
    [disabled]="isDisabled"
    (keypress)=" isPassword ? utils.validateKeySecurity($event.key) : true"
    (ionInput)="validatePercentageInput($event)"
  >
  <img 
    class="percent-icon" 
    *ngIf="(isFocus || hasValue)" 
    src="../assets/icons/percent.svg"
    alt="percent-icon"
  >
  </ion-input>
  
  <span
    class="error-message"
    *ngIf="errorMessage && !formControl.valid && hasValue"
  >
    {{ errorMessage }}
  </span>
</div>
